import { app , mobileView,  mainContainer, isTouchDevice, viewportInstances,} from '../app'
import { mousePos, heldDuration, mouseDown} from '../screens/default';
import { BitmapText, Container, Filter, Sprite, SplitText, Rectangle, FederatedPointerEvent, Graphics} from 'pixi.js';
import { interpColour, maxAbs } from '../utils/customMaths';
import { CartoonTextFilter } from '../assets/filters/CartoonTextFilter';
import { OutlineFilter } from 'pixi-filters';
import { currentPalette } from '../palettes';
import { findSettingByID, settingValue } from '../settings';
import { ViewportSprite } from './ViewportSprite';
import { ViewportText } from './ViewportText';

export abstract class ViewportInstance extends Container {

    private _destContainer!: Container;
    
    public get destContainer(): Container {
        return this._destContainer;
    }
    public set destContainer(value: Container) {
        this._destContainer = value;
    }

    private _perX: number = 0;
    private _perY: number = 0;
    private _destX: number = 0;
    private _destY: number = 0;
    private _width: number = 0;
    private _height: number = 0;
    public get height(): number {
        return this._height;
    }
    public set height(value: number) {
        this._height = value;
    }
    
    private _minWidth: number | undefined;
    public get minWidth(): number | undefined {
        return this._minWidth;
    }
    public set minWidth(value: number | undefined) {
        this._minWidth = value;
    }
    private _minHeight: number | undefined;
    public get minHeight(): number | undefined {
        return this._minHeight;
    }
    public set minHeight(value: number | undefined) {
        this._minHeight = value;
    }
    
    private _maxWidth: number | undefined;
    public get maxWidth(): number | undefined {
        return this._maxWidth;
    }
    public set maxWidth(value: number | undefined) {
        this._maxWidth = value;
    }
    private _maxHeight: number | undefined;
    public get maxHeight(): number | undefined {
        return this._maxHeight;
    }
    public set maxHeight(value: number | undefined) {
        this._maxHeight = value;
    }

    // private _height: number = 0;
    
    private _moveSpeed: number = -1;
    private isMoving = false;
    private _customFilters: Filter[] | undefined;
    private _attachment: BitmapText | Sprite | Graphics| Container | undefined;

    private _pressed: number = 0.0;
    public get pressed(): number {
        return this._pressed;
    }
    public set pressed(value: number) {
        this._pressed = value;
    }
    private mouseHeld: boolean = false;
    private mouseClicked: boolean = false;
    private mouseRising: boolean = false;
    private clickAnimationActive: boolean = false;

    private colour1: number = currentPalette ? currentPalette.text1 : 0xaaaaaa;
    private colour2: number = currentPalette ? currentPalette.text2 : 0xaaaaaa;

    private _gsapOffset: number[] = [0.0, 0.0];
   
    private _hitAreaMult?: number | undefined;
    public get hitAreaMult(): number | undefined {
        return this._hitAreaMult;
    }
    public set hitAreaMult(value: number | undefined) {
        this._hitAreaMult = value;
    }

    private _clickFunction?: (() => void) | undefined; //optional attach function for on button press


    private update;

    public staticBounds: boolean = true;

    private _lightColours: boolean = false;
    public set lightColours(value: boolean) {
        this._lightColours = value;
    }
    
    //screen percentile location
    public get perX(): number {
        return this._perX;
    }
    public set perX(value: number) {
        this._perX = value;
    }
    public get perY(): number {
        return this._perY;
    }
    public set perY(value: number) {
        this._perY = value;
    }
    //desired percentile location
    public get destX(): number {
        return this._destX;
    }
    public set destX(value: number) {
        this._destX = value;
    }
    public get destY(): number {
        return this._destY;
    }
    public set destY(value: number) {
        this._destY = value;
    }
    //move speed for reaching destination
    public get moveSpeed(): number {
        return this._moveSpeed;
    }
    public set moveSpeed(value: number) {
        this._moveSpeed = value;
    }
    public get attachment(): any {
        return this._attachment
    }
    public set attachment(value: any){
        this._attachment = value;
    }
    public get customFilters(): Filter[] | undefined {
        return this._customFilters
    }
    public set customFilters(value: Filter[]) {
        this._customFilters = value;
    }
    // public set customFilters(value: Filter[] | undefined) {
    //     this._customFilters = value;
    // }
    // public get height(): number {
    //     return this._height;
    // }
    // public set height(value: number) {
    //     this._height = value;
    // }
    public get width(): number {
        return this._width;
    }
    public set width(value: number) {
        this._width = value;
    }


    public get gsapOffset(): number[] {
        return this._gsapOffset;
    }
    public set gsapOffset(value: number[]) {
        this._gsapOffset = value;
    }
   

    public get clickFunction(): (() => void) | undefined {
        return this._clickFunction;
    }
    public set clickFunction(value: (() => void) | undefined) {
        this._clickFunction = value;
    }

    
    
    constructor(destContainer: Container, perX?: number, perY?: number, moveSpeed? : number, customFilters? : Filter[], clickFunction?: () => void) {
        super();
        this.perX = perX ?? 0.5;
        this.perY = perY ?? 0.5;
        this.destX = perX ?? 0.5;
        this.destY = perY ?? 0.5;
        this.moveSpeed = moveSpeed ?? -1;
        this.destContainer = destContainer;

        this.clickFunction = clickFunction;
        
       

        this._customFilters = customFilters ?? [
          
            
            new CartoonTextFilter({
                thickness: 2,
                isTouchDevice: isTouchDevice
            }),
            
            new OutlineFilter({
                alpha: 1,
                thickness: 1,
                quality: 0.1
            }),
            new OutlineFilter({
                alpha: 1,
                thickness: 2,
                quality: 0.1 
            })
        ]; //set array of filters in order - default filters can be overridden, or disabled with 'null'

        this.update = () => {
            // console.log("updating colours for instances")
            if (this._lightColours) {
                this.colour1 = interpColour(currentPalette.text1, 0xffffff, 0.8);
                this.colour2 = interpColour(currentPalette.text2, 0xffffff, 0.8);
            } else{
                this.colour1 = currentPalette.text1;
                this.colour2 = currentPalette.text2;
            }
            

            //update filter colours
            if (this.customFilters && this.customFilters.length !== 0) {
                for (const filter of this.customFilters) {
                    if (filter instanceof CartoonTextFilter) {
                        filter.color = [this.colour2, this.colour1]
                    } 
                }
            }
        }

        // this.init();
    }

    /**
     * @deprecated Inapplicable
     */
    findSize(){
        // if (!this.minHeight || !this.minWidth) this.width = 0.1;

        if (!this.minHeight && !this.minWidth) {
            return this.width = 0.1;
        }
        const windowRatio = app.renderer.height/app.renderer.width;
        const widthMinPixels = this.minWidth ? app.renderer.width*this.minWidth : 0;
        const widthMaxPixels = this.maxWidth ? app.renderer.width*this.maxWidth : undefined;
        const heightMinPixels = this.minHeight ? app.renderer.height*this.minHeight*windowRatio : 0;
        const heightMaxPixels = this.maxHeight ? app.renderer.height*this.maxHeight*windowRatio : undefined;

        let minPixels = widthMinPixels > heightMinPixels ? this.minWidth : this.minHeight;
        if (minPixels === undefined) minPixels = 0;
        const min = widthMinPixels > heightMinPixels ? this.minWidth : this.minHeight;
        
        const exceededMaxes = [];
        if (widthMaxPixels) exceededMaxes.push({pixels: widthMaxPixels, isWidth: true})
        if (heightMaxPixels) exceededMaxes.push({pixels: heightMaxPixels, isWidth: false});
        exceededMaxes.filter(max => {
            if (max.pixels < minPixels) return true
        })
        exceededMaxes.sort((a,b) => a.pixels - b.pixels);
        const finalMin = (exceededMaxes.length > 0) ? (
            exceededMaxes[0].isWidth?
            this.maxWidth :
            this.maxHeight
        ) : min;

        this.width = finalMin ? finalMin : 0;
        // this.height = this.width/windowRatio;

        // const widthPixels = this.minWidth ? app.renderer.width*this.minWidth : undefined;
        // const heightPixels = this.minHeight ? app.renderer.height*this.minHeight : undefined;
        // if (this.minHeight && heightPixels && (!widthPixels ||  heightPixels >= widthPixels)) this.width = this.minHeight/app.renderer.width*app.renderer.height
        // else if (this.minWidth && widthPixels) this.width = this.minWidth;
        // else this.width = this.maxWidth!;
    }

    updateOnce(){
        this.update();
    }

    /**
     * Changes destination position and movement speed, then triggers move action
     * @param destX 
     * @param destY 
     * @param moveSpeed 
     */
    moveTo(destX: number, destY: number, moveSpeed: number){
        this.destX = destX;
        this.destY = destY;
        this.moveSpeed = moveSpeed;
        this.updatePos();
    }

    /**
     * Updates current percentile location based upon speed - will decelerate toward point
     */
    updatePos(){

        this.updatePixel(); //update immediagtely

        //if (this.destX === this.perX && this.destY === this.perY) return;
        if (this.isMoving) {
            // console.log("i'm already moving")
            return;
        } else {
            this.isMoving = true;
        };
        

        const step = () => {
            if (this.moveSpeed === 0) {
                this.isMoving = false;
                return;
            }
            else if (this.moveSpeed < 0) {
                this.perX = this.destX;
                this.perY = this.destY;
            } else {
                this.perX = this.perX + maxAbs((this.destX-this.perX)*(this.moveSpeed/100), 0.00001);
                this.perY = this.perY + maxAbs((this.destY-this.perY)*(this.moveSpeed/100),0.00001);
            }

            const dx = Math.abs(this.destX - this.perX);
            const dy = Math.abs(this.destY - this.perY);

            if (dx < 0.00001 && dy < 0.00001) {
                this.perX = this.destX;
                this.perY = this.destY;
                this.isMoving = false;
                return;
            }

            this.updatePixel();

            //call recursively until at destination
            requestAnimationFrame(step);

        } 

        requestAnimationFrame(step);
    }

    /**
     * Find pixel location for object based on screen width and height
     */
    updatePixel(){

        this.x = Math.round(this.perX*app.screen.width/2);
        
        this.y = Math.round(this.perY*app.screen.height/2);
        // console.log("My boxy:" + this.x+ " ("+this.perX*100+"%) : " + this.y+" ("+this.perY*100+"%)")
        // console.log("MY DESTINATION? "+this.destX+" : "+ this.destY)
        if (!this.attachment || !this.customFilters || this.customFilters.length === 0) return
        for (const filter of this.customFilters) {
            if (filter instanceof CartoonTextFilter) {
                filter.origin = [this.attachment.getBounds().x - this.attachment.getLocalBounds().x, 
                    this.attachment.getBounds().y  - this.gsapOffset[1]];
            } 
        }
    }

    resize() {
        // console.log("Resizing")
        const mobileMult = (mobileView) ? 1 : 1;

        let b = this.attachment.getLocalBounds();
        
        if (this.staticBounds) {
            this.attachment.boundsArea = new Rectangle(b.x, b.y, b.width, b.height);
            this.boundsArea = new Rectangle(b.x, b.y, b.width, b.height);
        }
        

        let pixelHeight, pixelWidth;
        if (this.minHeight) {
            pixelHeight = this.minHeight*app.screen.height;
            this.height = this.minHeight;
        } else if (this.minWidth) {
            pixelWidth = this.minWidth*app.screen.width;
            this.width = this.minWidth;
        }
        
        const finalScale = pixelWidth ?
            pixelWidth/b.width * mobileMult :
            pixelHeight ?
                pixelHeight/b.height * mobileMult :
                1;
        
        if (this.attachment && ( this.attachment instanceof SplitText || this.attachment instanceof Sprite )) {
            this.attachment.scale.set(finalScale)
            
            //increase hitarea

            const filterArea = this.attachment.filterArea;
            if (filterArea){

                const width = b.width + 10/this.attachment.scale.x;
                const height = b.height+ 3/this.attachment.scale.y;
                const areaMult = (this.hitAreaMult ?? 1);

                this.attachment.hitArea = new Rectangle(
                    filterArea.x-5/this.attachment.scale.x+(width*(1-areaMult)), 
                    filterArea.y+(height*(1-areaMult)), 
                    width*areaMult, 
                    height*areaMult
                );
                
            }

        } 
        // if (this.attachment && this.attachment instanceof Sprite ) {
        //     this.attachment.rotation += 0.4
        // }

        if (!this.attachment || !this.customFilters || this.customFilters.length === 0) return
        for (const filter of this.customFilters) {
            if (filter instanceof CartoonTextFilter) {
                
                filter.screenSize = [app.screen.width,app.screen.height];
                filter.origin = [Math.max(0, this.attachment.getBounds().x - this.attachment.getLocalBounds().x), 
                    Math.max(0, this.attachment.getBounds().y  - this.gsapOffset[1])];
                const filterHeight = Math.min(app.renderer.height, this.attachment.getBounds().width + this.attachment.getLocalBounds().x)
                const filterWidth = Math.min(app.renderer.width, this.attachment.getBounds().height+ this.attachment.getLocalBounds().y*this.attachment.scale.y)
                filter.filterSize = [filterHeight ,
                    filterWidth]
                // filter.scale = finalScale*10; can't scale filter in this way as scales vary drastically according to input resolution, too inconsistent
                
            } 
        }


    }

    init(){
        if (this._attachment) {
            //applying filters to this instead of this.attachment resolves rotation distortion - but causes inconsistencies in text
            if (this instanceof ViewportSprite) {
                this.filters = this.customFilters;
            } else {
                this._attachment.filters = this.customFilters;
            }
            
            this.attachment.eventMode = 'static';

            this.attachment.on('pointerdown', (e: FederatedPointerEvent) =>{
                app.canvas.setPointerCapture(e.pointerId);
                this.mouseHeld = true;
                if (this.clickFunction) {
                    this.clickAnimation();
                }
                
                console.log (this.attachment.text+ "... Dimensions: h"+this.height+" w"+this.width+" s"+this.attachment.scale.x)
                
                // console.log("pressed")
            })

            this.attachment.on('pointerover', (e: FederatedPointerEvent) =>{
                if (!mouseDown) return;
                app.canvas.setPointerCapture(e.pointerId);
                
                this.mouseHeld = true;
                if (this.clickFunction) {
                    this.clickAnimation();
                }
            })

            this.attachment.on('pointerup', (e: FederatedPointerEvent) => {
                app.canvas.setPointerCapture(e.pointerId);
                this.mouseRising = false;
                this.mouseClicked = true;
                if (this.clickFunction) {
                    this.clickAnimation();
                }
                
                this.clickFunction?.();
            })

            // this.attachment.on('pointercancel', () => {
            //     this.mouseRising = false;
            //     this.mouseClicked = true;
            //     this.clickAnimation();
            // })

            //mobile equivalent
            this.attachment.on('touchend', () => {
                this.mouseRising = false;
                this.mouseClicked = true;
                if (this.clickFunction) {
                    this.clickAnimation();
                }
                // console.log("click")
            })

            this.attachment.on('pointerupoutside', (e: FederatedPointerEvent) => {
                app.canvas.setPointerCapture(e.pointerId);
                this.mouseHeld = false;
                this.mouseClicked = false;
                // console.log("up out")
            })

            this.attachment.on('pointerout', () => {
                this.mouseHeld = false;
                // this.mouseClicked = false;
                // console.log("moved away")
            })

            

        }

        this.updateSettings(); //update from default settings
        
        // if (this.attachment)
        this.destContainer.addChild(this)
        viewportInstances.push(this);
        
        // this.update()

    }

    updateLighting(): void{
        if (!this.attachment || !this.customFilters || this.customFilters.length === 0) return
        for (const filter of this.customFilters) {
            if (filter instanceof CartoonTextFilter) {
                filter.mouse  = [mousePos[0] , mousePos[1] ]
                filter.mousePressed = Math.max(Math.min(1.0, heldDuration), 0.0);
                filter.depth = this.pressed;
            } 
        }
    }

    clickAnimation(): void{


        const step = () => {

            if ( this.mouseRising && this.pressed > 0.0) {
                this.pressed -= 0.2;
            }
            else if (this.mouseClicked ) {
                this.pressed += this.pressed > 0.4 ? 0.025 : 0.1;
                if ( this.pressed >= 0.8) {
                    this.mouseRising = true;
                }
            }
            else if ( this.mouseHeld && this.pressed < 0.4 ) {
                this.pressed += 0.1;
            } else { 
                this.pressed -= 0.1;
            }

            //break if complete
            if ( this.pressed <= 0.0) {
                this.pressed = 0.0;
                this.mouseClicked = false;
                this.mouseRising = false;
                this.mouseHeld = false;
                this.clickAnimationActive = false;
            }
            if ( this.pressed > 0.0) {
                requestAnimationFrame(step);
            }

        }

        if (!this.clickAnimationActive) {
            requestAnimationFrame(step);
        }
    
    }

    updateSettings(){
        if (this.customFilters && this.customFilters.length !== 0) {
            for (const filter of this.customFilters) {
                if (filter instanceof CartoonTextFilter) {
                    filter.depthShading = settingValue(findSettingByID(15)) ?? 0 
                    filter.dropShadows = settingValue(findSettingByID(16)) ?? 0
                    filter.hardLighting = settingValue(findSettingByID(17)) ?? 0 
                    filter.softLighting = settingValue(findSettingByID(18)) ?? 0 
                    filter.castDistance = settingValue(findSettingByID(19)) ?? 50
                } 
            }
        }
    }

    

    updateTextColour(isOn: boolean){
        if (isOn) {
            
            app.ticker.add(this.update)
        } else {
            app.ticker.remove(this.update)
        }
    }

    

}